// Actions
import { createAction } from "redux-actions";
import types from "./types";

export default {
  serverSideErrorHandler: createAction(types.SERVER_SIDE_ERROR_HANDLER),
};
